import { Box, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/system';
import { get } from 'lodash';
import React, { FC } from 'react';
import MarkdownRenderer from '../../../../../components/ui-component/markdown-renderer/MarkdownRenderer';
import { useFoerderProgramm } from '../../../../../context/FoerderProgrammContext';
import { STRAPI_URL } from '../../../../../lib/constants/url';

// import schemas
import FoerderRichtlinieSchema from 'src/lib/paths/foerderrichtlinie_DETAILS_SEITE_Paths.json';
let FR_P = FoerderRichtlinieSchema.attributes;

const FoerderProgrammHeroSection: FC<{}> = () => {
	const { foerderRichtlinieDetails } = useFoerderProgramm();
	return (
		<Box
			sx={{
				background: `url(${STRAPI_URL + get(foerderRichtlinieDetails, FR_P.Medien_Downloads_Programmbild_Banner.path + '.attributes.url')})`,
				backgroundRepeat: 'no-repeat',
				backgroundSize: 'cover',
				padding: '2.8rem 0',
			}}
		>
			<Stack
				direction={'row'}
				spacing={2}
				alignItems={'center'}
				justifyContent={'flex-start'}
				sx={{
					backgroundColor: (theme) => alpha(theme.palette.common.white, 0.75),
					padding: '8px 32px 8px 16px',
					width: 'fit-content',
				}}
			>
				<Box sx={{ width: '1.4rem', height: '1.4rem', backgroundColor: 'navbar.secondary.active' }}></Box>
				<Typography variant='h1' sx={{ fontSize: '1.375rem' }}>
					{' '}
					{get(foerderRichtlinieDetails, FR_P.Allgemein_Titel_Deutsch.path, '')}
				</Typography>
			</Stack>

			<Typography
				component='div'
				sx={{
					backgroundColor: (theme) => alpha(theme.palette.common.white, 0.75),
					padding: '8px 32px 8px 16px',
					width: 'fit-content',
					mt: '2rem',
				}}
			>
				<MarkdownRenderer markdown={get(foerderRichtlinieDetails, FR_P.Allgemein_Kurzbeschreibung.path, '')} />
			</Typography>
		</Box>
	);
};

export default FoerderProgrammHeroSection;
